// @ts-nocheck
/* eslint-disable */
'use strict';

export class FieldChangedEventArgs {
    public FieldName: string = '';
    public FieldValue: string = '';

    public constructor(field: string, value: string) {
        this.FieldName = field;
        this.FieldValue = value;
    }
}
